import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import MortgageRatesByCity from "@/pages/MortgageRatesByCity";

export const Route = createFileRoute("/mortgage-rates/city/$city")({
  head: ({ params }) => seoHead(`/mortgage-rates/city/${params.city}`),
  component: MortgageRatesByCity,
});
